const findLabel = (code) => {
    let label = '';
    switch (code) {
        case 'EFX_LEGAL_NAME':
            label = 'Legal Business Name'
            break;
        case 'EFX_LEGSUBNUMALL':
            label = 'Legal Subsidiary - Parent Name'
            break;
        case 'ID_TYPE':
            label = 'Business tax ID type'
            break;
        case 'EIN':
            label = 'Employer Identification Number (EIN)'
            break;
        case 'EFX_NAME':
            label = 'Business Name (DBA)'
            break;
        case 'EFX_EMAIL':
            label = 'Business Email'
            break;
        case 'EFX_WEB':
            label = 'Website'
            break;
        case 'EFX_PHONE':
            label = 'Business Phone Number'
            break;
        case 'EFX_FAXPHONE':
            label = 'Business Fax Number'
            break;
        case 'EFX_ADDRESS':
            label = 'Address'
            break;
        case 'EFX_CITY':
            label = 'City'
            break;
        case 'EFX_STATE':
            label = 'State'
            break;
        case 'EFX_ZIPCODE':
            label = 'Zip Code'
            break;
        case 'EFX_CTRYISOCD':
            label = 'Country'
            break;
        case 'EFX_CONTCT':
            label = 'Primary Contact Name'
            break;
        case 'EFX_TITLECD':
            label = 'Primary Contact Title'
            break;
        case 'PRIMARY_PHONE':
            label = 'Primary Phone Number'
            break;
        case 'PRIMARY_EMAIL':
            label = 'Primary Email'
            break;
        case 'EFX_PRIMNAICSDESC':
            label = 'Primary Industry'
            break;
        case 'EFX_YREST':
            label = 'Year Established'
            break;
        case 'DESCRIPTION':
            label = 'Company Description'
            break;
        case 'EFX_CORPEMPCNT':
            label = 'Estimated Number of Employees - Corporate'
            break;
        case 'EFX_CORPAMOUNT':
            label = 'Estimated Annual Revenue - Corporate'
            break;
        case 'EFX_FOREIGN':
            label = 'US Owned'
            break;
        case 'EFX_PUBLIC':
            label = 'Public Company'
            break;
        case 'EFX_VET':
            label = 'Veteran Owned'
            break;
        case 'EFX_WBE':
            label = 'Female Owned'
            break;
        case 'EFX_MBE':
            label = 'Minority Owned'
            break;
        case 'EFX_GOV':
            label = 'Government Entity'
            break;
        case 'EFX_FGOV':
            label = 'Federal Government Entity'
            break;
        case 'EFX_NONPROFIT':
            label = 'Non-Profit Entity'
            break;
        case 'EFX_EDU':
            label = 'Educational Institutional Indicator'
            break;

        default: label = 'Check API';

    }
    return label
}

export default findLabel;
